<template>
  <div
    class="rounded-large group bg-surface-container group @container relative flex grow cursor-pointer flex-col items-center overflow-hidden"
    @click="navigateToImpulse"
  >
    <div class="rounded-large relative z-20 aspect-10/3 w-full shrink-0 overflow-hidden">
      <img
        v-if="impulse.image"
        :src="impulse.image"
        alt=""
        class="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105 group-hover:rotate-1"
      />
      <LessonImpulseBookmarkButton
        :impulse="impulse"
        color="filled"
        toggle
        class="absolute! top-3 right-3 z-30"
      />
      <div
        v-if="impulse.myLessonCounts.running > 0 || impulse.myLessonCounts.finished > 0"
        class="absolute top-4 left-4 z-30 flex flex-col items-start gap-1"
      >
        <RouterLink
          v-if="impulse.myLessonCounts.running > 0"
          :to="{ name: 'impulse-library' }"
          @click.stop
        >
          <div
            class="bg-primary text-on-primary rounded-small text-label-medium flex flex-row items-center gap-2 px-2 py-1"
          >
            <div class="bg-on-primary animate-color-pulse h-2 w-2 rounded-full"></div>
            <span>
              {{ $t('lumia.lesson.running') }}
            </span>
          </div>
        </RouterLink>
      </div>
    </div>
    <div class="flex w-full grow flex-col gap-2">
      <div class="mb-3 flex w-full flex-row flex-wrap gap-1 overflow-hidden pt-4">
        <BaseHorizontalOverflow @mousedown.stop>
          <div class="flex w-fit flex-row gap-1 px-4">
            <BaseChip
              v-for="kompetenz in impulse.ueberfachlicheKompetenzen"
              :key="kompetenz.id"
              :color="colorForUeberfachlicheKompetenz(kompetenz)"
              class="shrink-0"
            >
              {{ kompetenz.title }}
            </BaseChip>
            <BaseChip v-if="impulse.isStandortbestimmung" class="shrink-0">
              {{ $t('lumia.sections.standortbestimmung') }}
            </BaseChip>
          </div>
        </BaseHorizontalOverflow>
      </div>
      <div class="flex grow flex-col px-4 pb-4">
        <h3 class="text-title-large @sm:text-headline-small">{{ impulse.title }}</h3>
        <span class="text-body-medium text-on-surface-variant mt-1 line-clamp-3">
          {{ impulse.abstract }}
        </span>
      </div>
      <div
        class="border-outline-variant text-body-medium text-on-surface-variant flex flex-row flex-wrap items-center gap-0.5 border-t p-4"
      >
        <LessonImpulseSubjects :subjects="impulse.subjects" class="font-medium" />
        ・
        <span class="inline-flex flex-row items-center gap-1">
          <BaseIcon size="18">schedule</BaseIcon
          >{{ $t('lumia.numberOfLessons', { count: impulse.numberOfLessons }) }}
        </span>
        <span v-if="gradeClassLabel(impulse.grades)">
          ・ {{ gradeClassLabel(impulse.grades) }}
        </span>
        <span
          v-if="impulse.myLessonCounts.finished > 0"
          v-tooltip="
            `${$t('lumia.lesson.myCountFinished', { count: impulse.myLessonCounts.finished })}`
          "
          class="inline-flex flex-row items-center gap-0.5"
        >
          ・ <BaseIcon size="18">repeat</BaseIcon> {{ impulse.myLessonCounts.finished }}
        </span>
      </div>
    </div>
    <BaseStateLayer :type="color" />
  </div>
</template>
<script lang="ts" setup>
  import { useRouter } from 'vue-router'
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import { gradeClassLabel, type LessonImpulseSummary } from '../models/lesson-impulse'
  import { colorForUeberfachlicheKompetenz } from '../models/ueberfachliche-kompetenz-color.ts'
  import LessonImpulseSubjects from './LessonImpulseSubjects.vue'
  import BaseChip from '@/core/components/base/chip/BaseChip.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseHorizontalOverflow from '@/core/components/base/horizontal-overflow/BaseHorizontalOverflow.vue'
  import LessonImpulseBookmarkButton from './LessonImpulseBookmarkButton.vue'
  import { computed } from 'vue'

  interface Props {
    impulse: LessonImpulseSummary
  }

  const props = defineProps<Props>()
  const router = useRouter()

  const navigateToImpulse = () => {
    router.push({
      name: 'impulse-library-detail',
      params: { id: props.impulse.id },
    })
  }

  const color = computed(() => {
    return colorForUeberfachlicheKompetenz(props.impulse.ueberfachlicheKompetenzen[0])
  })
</script>
